const parser = new DOMParser();

export const decodeDisplayText = (value?: string): string => {
    if (!value) return '';
    const docData = parser.parseFromString(value, 'text/html');
    return (docData.documentElement.textContent ?? '')
        .replace(/\\(['"])/g, '$1');
};

export default {
    decodeDisplayText,
};
